define(function(require){
    'use strict';

    var Rivets = require('rivets');

    Rivets.formatters['=='] = function(first, second){
        return first == second;
    };

    Rivets.formatters['==='] = function(first, second){
        return first === second;
    };

    Rivets.formatters['!='] = function(first, second){
        return first != second;
    };

    Rivets.formatters['?>'] = function(first, second){
        if (first > second)
            return first - second;
        else 
            return second;
    };

    Rivets.formatters['+'] = function(first, second){
        return first + second;
    };

    Rivets.formatters['>'] = function(first, second){
        return first > second;
    };

    Rivets.formatters['-'] = function(first, second){
        return first - second;
    };

    Rivets.formatters['or'] = function(first, second){
        return first || second;
    };

    Rivets.formatters['and'] = function(first, second){
        return first && second;
    };

    Rivets.formatters['?'] = function(first, second, third){
        if (first) return second;
        else return third;
    };

    Rivets.formatters['ifInt'] = function(first){
        return typeof first === 'number';
    };

    Rivets.formatters['link'] = function(first){
        return first && first.replace(/(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi, '$1<a href="$2" target="_blank">$2</a>') || '';
    };

    Rivets.formatters['plural'] = function(first, second, third, fourth){
        var number = Math.abs(first);
        var result;
        if(number == 0){
            result = fourth;
        }else{
            number %= 100;
            if (number >= 5 && number <= 20){
                result = fourth;
            }else{
                number %= 10;
                if (number == 1){
                    result = second;
                }else if(number >= 2 && number <= 4){
                    result = third;
                }else{
                    result = fourth;
                }
            }
        }
        return result;
    };
});
